//Comentario necesario para codificación en UTF-8, ver Inc6743
"use strict";

(function() {
	angular.module('pphhApp')
		.factory("CommonCatalogService", ["$http", "$q", CommonCatalogServiceFactory]);

	function CommonCatalogServiceFactory($http, $q) {
		return {
			getWaterModules: getWaterModules,
			getWaterModulesNoAux: getWaterModulesNoAux,
			getDirectives: getDirectives,
			getWaterModule: getWaterModule,
			getVersions: getVersions,
			getVersion: getVersion,
			getPlanHidrolActivo: getPlanHidrolActivo,
			getDemarcaciones:getDemarcaciones
		};

		function getWaterModules() {
			return $http.get("/cc/wms");
		}

		function getWaterModulesNoAux() {
			return $http.get("/cc/wms/noAux");
		}

		function getDirectives() {
			var deferred = $q.defer();

			$http.get("/cc/wms")
				.then(
					function(response) {
						var directives = {};
						angular.forEach(response.data, function(moduleObj) {
							var directive = directives[moduleObj.directive.name];
							if (!angular.isDefined(directive)) {
								directive = moduleObj.directive;
								directive.modules = [];
								directives[directive.name] = directive;
							}

							directive.modules.push(moduleObj);
						});

						var directiveArray = [];
						angular.forEach(directives, function(directive) {
							directiveArray.push(directive);
						});

						deferred.resolve(directiveArray);
					}

				);

			return deferred.promise;
		}

		function getWaterModule(name) {
			return $http.get("/cc/wm/" + name);
		}

		function getVersions(moduleName) {
			return $http.get("/snapshots/" + moduleName);
		}
		//03956 Modificacion de nombre y descripcion de la version
		function getVersion( cicloId, moduleName) {
			return $http.get("/snapshots/" + cicloId + "/" + moduleName );
		}

		function getPlanHidrolActivo(cicloId) {
			return $http.get("/cc/planHidrologicoActivo/" + cicloId);
		}
		
		function getDemarcaciones() {
			return $http.get("/cc/queries/todasDemarcaciones");
		}		
	}
})();
